import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, inject, input } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { log } from "console";
import * as _ from "lodash-es";
import { AlertService } from "src/app/services/alert.service";
import { AuthService } from "src/app/services/auth.service";
import { LoaderService } from "src/app/services/loader.service";
import { NotificationsService } from "src/app/services/notifications.service";
import { environment } from 'src/environments/environment';
import { MatButton } from "@angular/material/button";
import { NgClass } from "@angular/common";
import { MatMenuTrigger, MatMenu, MatMenuItem } from "@angular/material/menu";
import { MatDivider } from "@angular/material/divider";
import { MatTooltip } from "@angular/material/tooltip";
import { NotifListComponent } from "../notif-list/notif-list.component";
import { FormsModule } from "@angular/forms";
import { RxReactiveFormsModule } from "@rxweb/reactive-form-validators";
import { TranslatePipe } from "@ngx-translate/core";


// // @ts-ignore
// const api = require("@modules/cf-api.js").api;
// const api_async = require("@modules/cf-api.js").api_async;

@Component({
    selector: "app-nav",
    templateUrl: "./nav.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ["./nav.component.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [RouterLink, MatButton, NgClass, MatMenuTrigger, MatMenu, MatMenuItem, MatDivider, MatIcon, MatTooltip, NotifListComponent, FormsModule, RxReactiveFormsModule, TranslatePipe]
})
export class NavComponent implements OnInit {
    protected route = inject(ActivatedRoute);
    router = inject(Router);
    protected alert = inject(AlertService);
    protected cd = inject(ChangeDetectorRef);
    protected loaderService = inject(LoaderService);
    protected auth = inject(AuthService);
    protected s_notifications = inject(NotificationsService);


    public appRoutes = {
        home: "/",
        kiosk: environment.cfURL,
        admin: "/admin",
        printers: "/admin/printers-table",
        colors: "/admin/colorbooks",
        users: "/admin/users-table",
        groups: "/admin/groups-table",
        brands: "/admin/brands-table",
        archives: "/admin/inactive-projects",
        epson: "/admin/epson",
        stats: "/stats",
        account: "/my-account",
        'ed-dashboard': "/easydiadem/dashboard",
        'patch-notes': "/admin/patch-notes-table",
    };

    readonly userFullName = input<string>();
    readonly userEasydiadem = input<boolean>(false);

    @ViewChild("searchInput") searchInput: ElementRef | null = null;
    @ViewChild("searchIcon") searchIcon: MatIcon | null = null;

    isActive: boolean;
    sampleModel: string = "";
    cfURL: string = environment.cfURL;

    get notifs() {
        return this.s_notifications.entities;
    }

    get environment() {
        return environment;
    }

    async ngOnInit() {
        await this.s_notifications.init();
    }

    logout() {
        this.auth.logout();
        localStorage.removeItem('liveco-filters-project-dashboard');

    }

    userManual() {
        const userLang = this.auth?.user?.language || 'fr';
        let userManualPath = '/assets/FR_Manuel_Utilisation_Liveco_4.pdf';
        switch (userLang) {
            case 'en':
                userManualPath = "/assets/ENG_User_Manual_Liveco_4.pdf";
                break;
            case 'fr':
            default:
                // French manual, set above
                break;
        }
        window.open(userManualPath, "_blank");
    }

    isCPP(): boolean {
        return this.auth.isCPP();
    }

    isFab(): boolean {
        return this.auth.isFab();
    }

    isOperator(): boolean {
        return this.auth.isOperator();
    }

    isAdmin(): boolean {
        return this.auth.isAdmin();
    }

    isClient(): boolean {
        return this.auth.isClient();
    }

    searchOnMouseEnter(): void {
        if (this.searchInput) {
            this.searchInput.nativeElement.classList.add("hovered");
        }
        if (this.searchIcon) {
            this.searchIcon._elementRef.nativeElement.classList.add("hovered");
        }
    }

    searchOnMouseLeave(): void {
        if (this.searchInput) {
            this.searchInput.nativeElement.classList.remove("hovered");
        }
        if (this.searchIcon) {
            this.searchIcon._elementRef.nativeElement.classList.remove("hovered");
        }
    }

    updateDisplay(): void {
        if (this.searchInput && this.searchInput.nativeElement && this.searchInput.nativeElement.value && this.searchInput.nativeElement.value.length > 0) {
            this.searchInput.nativeElement.classList.add("hasValue");
        } else {
            this.searchInput?.nativeElement.classList.remove("hasValue");
        }
    }

    makeSearch(): void {
        if (this.searchInput && this.searchInput.nativeElement && this.searchInput.nativeElement.value && _.isString(this.searchInput.nativeElement.value) && this.searchInput.nativeElement.value.length > 0) {
            const isEasyDiadem = this.router.url.includes('/easydiadem/');

            let redirectUrl = '/';

            if (this.isCPP() && isEasyDiadem) {
                redirectUrl = '/easydiadem/dashboard';
            }

            // localStorage.setItem('dashboard-search', encodeURIComponent(this.searchInput.nativeElement.value));

            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate([redirectUrl], { queryParams: { identifier: this.searchInput.nativeElement.value } });
        }
    }

    // hasLimitedAccess(): boolean {
    //     return this.auth.hasCustomerLimitedAccess;
    // }

    isCurrentUrl(url: string, include: boolean = false, except?:string[]): boolean {
        if (include) {
            if (except && except.length > 0) {
                return this.router.url.includes(url) && !except.some(ex => this.router.url.includes(ex));
            }
            return this.router.url.includes(url);    
        }  else {
            return this.router.url === url;
        }
    }
}
